import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const SQL_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

const parsePickerDatetime = (value) => {
    if (!value) return null;
    const sqlDatetime = dayjs(value, SQL_DATETIME_FORMAT, true);
    if (sqlDatetime.isValid()) return sqlDatetime;
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed : null;
};

// MUI Components
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

const EmailForm = ({
    selectedSites = [],
    handleClose,
    existingEmail = null,
    content: sharedContent,
    setContent: setSharedContent,
    schedule: sharedSchedule,
    setSchedule: setSharedSchedule,
}) => {

    const isEdit = Boolean(existingEmail);

    const [schedule, setSchedule]               = useState(() => isEdit ? !existingEmail.is_sent : true);
    const [sendAt, setSendAt]                   = useState(() => isEdit ? parsePickerDatetime(existingEmail.send_at) : null);
    const [ subject, setSubject ]               = useState(() => isEdit ? (existingEmail.subject || '') : '');
    const [ content, setContent ]               = useState(() => isEdit ? (existingEmail.content || '') : '');

    const scheduleValue = isEdit ? schedule : sharedSchedule;
    const setScheduleValue = isEdit ? setSchedule : setSharedSchedule;
    const contentValue = isEdit ? content : sharedContent;
    const setContentValue = isEdit ? setContent : setSharedContent;

    const saveAlert = () => {
        let args = {
            type: 'email',
            schedule: scheduleValue,
            content: contentValue,
            subject: subject
        };
        if( scheduleValue ){
            args.send_at = sendAt.format('YYYY-MM-DD HH:mm:ss');
        }
        if( existingEmail ){
            axios.post('/email/' + existingEmail.id + '/update', args).then(response => {
                if( response.status === 200 && !response.data.error ){
                    toast.success(response.data.message);
                }
                else{
                    toast.error(response.data.message);
                }
                handleClose();
            });
        }
        else{
            args.sites = selectedSites;
            axios.post('/create-bulk-notices', args).then(response => {
                if( response.status === 200 && !response.data.error ){
                    toast.success(response.data.message);
                }
                else{
                    toast.error(response.data.message);
                }
                handleClose();
            }).catch(error => {
                toast.error(error.response?.data?.message || 'Email request failed');
            });
        }
    }

    return (
        <Box className='form'>
            <Box className='alert-form-field'>
                <TextField
                    label='Subject'
                    name='subject'
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    // full width
                    fullWidth
                />
            </Box>
            <Box className='alert-form-field'>
                <TextField
                    label='Content'
                    name='content'
                    value={contentValue}
                    onChange={(e) => setContentValue(e.target.value)}
                    multiline
                    minRows={10}
                    fullWidth
                />
                <p className='field-description'>You can use site property placeholders in the content including: {'{domain}'}, {'{admin_email}'}, {'{server_id}'}</p>
            </Box>
            <ButtonGroup>
                <Button onClick={() => setScheduleValue(true)} variant={scheduleValue ? 'contained' : 'outlined'}>Schedule</Button>
                <Button onClick={() => setScheduleValue(false)} variant={!scheduleValue ? 'contained' : 'outlined'}>Send</Button>
            </ButtonGroup>
            <Box className='alert-form-field'>
                {scheduleValue && (
                    <DateTimePicker
                        label='Send At'
                        name='sendAt'
                        value={sendAt}
                        onChange={(e) => setSendAt(e)}
                        TimeZone='America/Toronto'
                    />
                )}
            </Box>
            <Box className='alert-form-field'>
                {scheduleValue ? (
                    <Button onClick={() => saveAlert()} variant='contained'>Save</Button>
                ) : (
                    <Button onClick={() => saveAlert()} variant='contained'>
                        {existingEmail ? 'Update' : 'Send to ' + selectedSites.length + ' client' + (selectedSites.length > 1 ? 's' : '')}
                    </Button>
                )}
            </Box>
        </Box>
    )

}

export default EmailForm;
